import { useMemo, useRef } from 'react'

import { useOfflinePurchasesQuery, OfflinePurchase } from '@shared/generated'

const LIMIT = 10

export function useOfflinePurchasesInfinite () {
  const lastFetchedCountRef = useRef(0)

  const { data, loading, fetchMore } = useOfflinePurchasesQuery({
    variables: {
      limit: LIMIT,
      offset: 0,
    },
    notifyOnNetworkStatusChange: true,
    onCompleted: (res) => {
      lastFetchedCountRef.current = res.offlinePurchases?.length ?? 0
    },
  })

  const items = useMemo(() => {
    return (data?.offlinePurchases ?? []).filter(
      (item): item is OfflinePurchase => !!item,
    )
  }, [ data ])

  const hasMore = lastFetchedCountRef.current === LIMIT

  const loadMore = () => {
    if (!hasMore || loading) return

    fetchMore({
      variables: {
        limit: LIMIT,
        offset: items.length,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        const newItems = fetchMoreResult?.offlinePurchases ?? []

        lastFetchedCountRef.current = newItems.length

        return {
          ...fetchMoreResult,
          offlinePurchases: [ ...(prev.offlinePurchases ?? []), ...newItems ],
        }
      },
    })
  }

  return { items, loading, hasMore, loadMore }
}
